import React, { ReactElement, useEffect } from 'react'
import {
  CardWrapper,
  CardHeader,
  Loader,
  RankCircle
} from '../../../../components'
import { Container, Row } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'
import strings from '../../../../locale/en'
import { H2, Large, Small } from '../../../../typography'
import theme, { colors } from '../../../../const/theme'
import { ScoreCard, ScoreTitle, RankWrapper } from './subcomponents'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { getTestAverage } from '../../../../redux/test/action'
import { RootState } from '../../../../redux/store'

const OverallPerformanceCard = (): ReactElement => {
  const {
    isLoading,
    studentId = '',
    average,
    selectedBatch = ''
  } = useSelector(
    (state: RootState) => ({
      isLoading: state.test.isLoading,
      studentId: state.user?.userInfo?.userDetail?.usersId,
      average: state.test.average,
      selectedBatch: state.user.selectedBatch
    }),
    shallowEqual
  )

  const {
    assessment: {
      overallPerformance,
      yourAverageScore,
      classAveragescore,
      topperAverageScore,
      yourOverAllRank
    }
  } = strings
  const dispatch = useDispatch()

  useEffect(() => {
    if (selectedBatch) {
      dispatch(getTestAverage({ batchId: selectedBatch, studentId: studentId }))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBatch])

  return (
    <CardWrapper>
      <CardHeader>{overallPerformance}</CardHeader>
      <Card.Body>
        {isLoading ? (
          <Loader />
        ) : (
          <Container>
            <Row>
              <ScoreCard xs lg="2">
                <ScoreTitle borderColor={theme.performanceCard.yourScore}>
                  {yourAverageScore}
                </ScoreTitle>
                <Large>{`${average?.studentAverage.toFixed(2)}%`}</Large>
              </ScoreCard>
              <ScoreCard xs lg="3">
                <ScoreTitle borderColor={theme.performanceCard.classScore}>
                  {classAveragescore}
                </ScoreTitle>
                <Large>{`${average?.classAverage.toFixed(2)}%`}</Large>
              </ScoreCard>
              <ScoreCard xs lg="3">
                <ScoreTitle borderColor={theme.performanceCard.topperScore}>
                  {topperAverageScore}
                </ScoreTitle>
                <Large color={colors.gray}>{`${average?.topperAverage.toFixed(
                  2
                )}%`}</Large>
              </ScoreCard>
              <ScoreCard xs lg="4">
                <RankWrapper>
                  <RankCircle
                    rank={average?.rank || 0}
                    themeKey="performanceCard"
                  />
                  <div>
                    <H2 color={colors.gray}>{yourOverAllRank}</H2>
                    <Small
                      color={colors.gray}
                    >{`Out of ${average?.total_students} students`}</Small>
                  </div>
                </RankWrapper>
              </ScoreCard>
            </Row>
          </Container>
        )}
      </Card.Body>
    </CardWrapper>
  )
}

export default OverallPerformanceCard
